/**
 * @generated SignedSource<<849d87a2c6b6f84959dc2ff7f0340482>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleTopicFollowWidgetArticle$data = {
  readonly topics: ReadonlyArray<{
    readonly disableFollow: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "topicLinkTopic">;
  } | null> | null;
  readonly " $fragmentType": "articleTopicFollowWidgetArticle";
};
export type articleTopicFollowWidgetArticle$key = {
  readonly " $data"?: articleTopicFollowWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleTopicFollowWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleTopicFollowWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicLinkTopic"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityFollowButtonBase"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableFollow",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "b868776c4a9b080bbdeb07f3bdbfeebf";

export default node;
